<template>
  <section v-if="displayItems.length" class="ni-section ni-ask" id="qd-service">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="displaySubtitle"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ displayTitle }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-ask__grid">
        <a
          v-for="srv in displayItems"
          :key="srv.id"
          :id="`service-card-${srv.id}`"
          class="ni-ask__card"
          :class="{ 'ni-ask__card--title-only': srv.isTitleOnly }"
          :href="srv.redirectUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="ni-ask__card-icon">
            <img
              :src="srv.iconUrl"
              :alt="srv.lines[0] || ''"
              class="ni-ask__card-icon-img"
            />
          </div>
          <div class="ni-ask__card-text">
            <div
              v-for="(line, lineIdx) in srv.lines"
              :key="lineIdx"
              :class="lineIdx === 0 ? 'ni-ask__card-line1' : 'ni-ask__card-line2'"
            >
              {{ line }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SectionHeader from './shared/SectionHeader.vue';

const props = defineProps({
  section: {
    type: Object,
    default: () => ({ title: '', subtitle: '' }),
  },
  items: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();

const displayItems = computed(() => props.items || []);

const displayTitle = computed(
  () => props.section?.title || t('newIndex.sections.ask.title')
);

const displaySubtitle = computed(
  () => props.section?.subtitle || t('newIndex.sections.ask.subtitle')
);
</script>
